import * as React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  prompt: string;
  onSave: (updatedPrompt: string) => void;
}

export const EditPromptDialog: React.FC<Props> = ({ open, onOpenChange, prompt, onSave }) => {
  const [draftPrompt, setDraftPrompt] = React.useState(prompt);

  React.useEffect(() => {
    if (open) {
      setDraftPrompt(prompt);
    }
  }, [open, prompt]);

  const handleSave = () => {
    onSave(draftPrompt);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-3xl">
        <DialogHeader>
          <DialogTitle>Edit Analysis Prompt</DialogTitle>
        </DialogHeader>
        <Textarea
          value={draftPrompt}
          onChange={e => setDraftPrompt(e.target.value)}
          className="min-h-[500px] resize-none"
          placeholder="Edit the analysis prompt..."
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
